import { RouterModule } from '@angular/router';
import { GlobalModule } from '@techmore/global';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndexControllerComponent } from './component/index-controller/index-controller.component';
import { TechmoreFormModule } from '@techmore/form';
import { FormsModule } from '@angular/forms';
import { ShareModule } from '../../share/share.module';
import { DefaultQparamPipe } from './pipe/default-qparam.pipe';
import { TmWowModule } from '@techmore/wow';
import { IndexCollectionSelectorModalComponent } from './component/index-collection-selector-modal/index-collection-selector-modal.component';
import { IndexSubjectSelectorModalComponent } from './component/index-subject-selector-modal/index-subject-selector-modal.component';
import { DateTimePickerModule } from '@techmore/date-time-picker';
import { TechmoreSharedModule } from '@techmore/share';
import { ValidateModule } from '@techmore/validate';
import { ShareDataSearchModule } from 'src/app/data-search/share-data-search.module';
import { ViewEditorModule } from 'src/app/view-editor/view-editor.module';
import { DataSearchService } from 'src/app/data-search/data-search.service';
import { IndexCollectionGroupingModalComponent } from './component/index-collection-grouping-modal/index-collection-grouping-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { ImageUploadModalComponent } from './component/image-upload-modal/image-upload-modal.component';
import { IndexCollectionSettingModalComponent } from './component/index-collection-setting-modal/index-collection-setting-modal.component';
import { UploadModule } from '../../upload/upload.module';

@NgModule({
  declarations: [
    IndexControllerComponent,
    IndexSubjectSelectorModalComponent,
    IndexCollectionSelectorModalComponent,
    IndexCollectionGroupingModalComponent,
    IndexCollectionSettingModalComponent,
    ImageUploadModalComponent,
    DefaultQparamPipe,
  ],
  imports: [
    CommonModule,
    TechmoreFormModule,
    FormsModule,
    ShareModule,
    TmWowModule,
    GlobalModule,
    RouterModule,
    TechmoreSharedModule,
    ViewEditorModule,
    DateTimePickerModule,
    ValidateModule,
    ShareDataSearchModule,
    TranslateModule.forChild(),
    UploadModule,
  ],
  exports: [
    IndexControllerComponent,
    IndexSubjectSelectorModalComponent,
    IndexCollectionSelectorModalComponent,
    IndexCollectionGroupingModalComponent,
    IndexCollectionSettingModalComponent,
    ImageUploadModalComponent,
    DefaultQparamPipe,
  ],
  providers: [
    DataSearchService,
  ]
})
export class ShareIndexSectionModule { }
